import { useMutation } from '@tanstack/react-query';
import { postImageUserProfile } from '../../../../../api/etc/upload/mutations/postImageUserProfile';

export const usePostImageUserProfileMutation = () => {
  return useMutation(postImageUserProfile);
};
